import {applyMiddleware, createStore} from 'redux';
import rootReducer from "../Reducers/Index";
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
});
const store = createStore(rootReducer,composeEnhancers(applyMiddleware(thunk)));
export default store;